module.exports = "2"



// WEBPACK FOOTER //
// ./node_modules/virtual-dom/vnode/version.js